<template>
  <a-collapse
    v-model="activeKey"
    expandIconPosition="right"
    :bordered="false"
    class="outline-node"
  >
    <template #expandIcon="{ isActive }">
      <img
        src="@/assets/img/icon/icon8.png"
        alt=""
        :class="{ active: isActive }"
      />
    </template>
    <a-collapse-panel
      v-for="(el, index) in info"
      :key="el.id"
      :show-arrow="false"
    >
      <template #header>
        <p class="title">
          <img
            src="@/assets/img/sjxicon.png"
            alt=""
            class="outline-node-jt"
            v-if="el.contentList || el.children.length > 0"
          />
          <span
            >第{{ index + 1 }}课<span>{{ el.chapterName }}</span></span
          >
          <a-button
            size="small"
            v-if="el.videoType === '2'"
            @click.stop="studyCoures(el.videoUrl)"
            >观看课程</a-button
          >
        </p>
      </template>
      <CoursewareList v-if="el.contentList" :info="el.contentList" />
      <a-collapse
        v-model="activeKeyItem"
        expandIconPosition="right"
        :bordered="false"
        class="outline-node"
      >
        <template #expandIcon="{ isActive }">
          <img
            src="@/assets/img/icon/icon8.png"
            alt=""
            :class="{ active: isActive }"
          />
        </template>
        <a-collapse-panel
          v-for="(item, i) in el.children"
          :key="item.id"
          :show-arrow="false"
        >
          <template #header>
            <p class="title" style="padding-left: 30px">
              <img
                src="@/assets/img/yqicon.png"
                alt=""
                v-if="item.contentList"
              />
              <span
                >第{{ i + 1 }}讲<span>{{ item.chapterName }}</span></span
              >
              <a-button
                size="small"
                v-if="el.videoType === '2'"
                @click.stop="studyCoures(el.videoUrl)"
                >观看课程</a-button
              >
            </p>
          </template>
          <CoursewareList
            :padding="68"
            v-if="item.contentList"
            :info="item.contentList"
          />
        </a-collapse-panel>
      </a-collapse>
    </a-collapse-panel>
  </a-collapse>
</template>

<script>
import CoursewareList from "./coursewareList.vue";
import { courseStudy } from "@/api/activity";
import { mapGetters } from "vuex";
export default {
  props: {
    info: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    CoursewareList,
  },
  computed: {
    ...mapGetters(["userInfo"]),
    id: function () {
      return this.$route.query.id;
    },
  },
  data() {
    return {
      activeKeyItem: [],
      activeKey: [],
    };
  },
  methods: {
    async studyCoures(url) {
      if (!this.userInfo) {
        this.$message.warning("您还未登录！");
        return;
      }
      await courseStudy({
        courseId: this.id,
        userId: this.userInfo.id,
      });
      window.open(url);
    },
  },
};
</script>

<style scoped lang="scss">
.outline-node {
  .title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 400;
    color: #262626;
    line-height: 22px;
    position: relative;
    > img {
      margin-right: 8px;
    }
    > span {
      > span {
        margin-left: 8px;
      }
    }
    > button {
      position: absolute;
      right: 0;
    }
  }
  .outline-node-jt {
    transition: all 0.3s;
  }
  ::v-deep .ant-collapse-item-active {
    .outline-node-jt {
      transform: rotate(90deg);
    }
  }
}
</style>
